import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { MainContext } from '../../context';
import 'react-toastify/dist/ReactToastify.css';
import { gsap, Power1 } from 'gsap';
import { useNavigate, useLocation } from 'react-router-dom';
import { AgentListItem, AgentListWrapper } from './AgentProfile/AgentProfile';
import { getUserType } from '../../utils/common';
import { getAgents } from '../../services/admin';
import { Loader } from '../../components/loader';

export const DashboardSidebarContainer = styled.aside`
  display: flex;
  align-items: flex-start;
  position: fixed;
  top: ${(props) => props.top}px;
  left: -9999px;
  z-index: 201;
  transition: all 0.5s ease;
  border-right: 4px solid #7ba4e9;
`;

export const DashboardSidebarHover = styled.div`
  width: 30px;
  position: absolute;
  left: 0;
  border-right: 4px solid #7ba4e9;
  background-color: #e8e8e8;
  top: 0px;
  min-height: 100vh;
`;

export const DashboardSidebarWrapper = styled.div`
  display: flex;
  width: 250px;
  padding-bottom: 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  background: var(--ywh-mercury, #e8e8e8);
  overflow: hidden;
  height: 100vh;
  z-index: 310;

  ${
    '' /* ::-webkit-scrollbar {
    display: none;
  } */
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  min-height: 100vh;
  max-width: 1900px;
  width: 100%;
  margin: 0 auto;
  position: relative;

  & aside {
    margin-bottom: -4rem;
    flex: 0 0 20%;
    background-color: #e8e8e8;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 120px 0px 120px 48px;

    & ul {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      align-self: stretch;
      & li {
        display: flex;
        padding: 32px 0px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        cursor: pointer;

        &.active {
          border-radius: 8px 0px 0px 8px;
          background: #fff;
        }
      }
    }
  }

  & section {
    flex: 1;
    background: #fff;
  }
`;

export const StaticMenuContainer = styled.div`
  display: flex;
  padding: 14px 80px;
  align-items: center;
  align-content: center;
  gap: 64px;
  align-self: stretch;
  flex-wrap: wrap;
  background: #e8e8e8;
  position: sticky;
  width: 100%;
  top: 0px;
  z-index: 200;
  transition: all 0.5s ease;
  margin:;
`;

export const StaticMenuWrapper = styled.div`
  display: flex;
  min-width: 470px;
  max-width: 1740px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  margin: 0 auto;
  width: 100%;
`;

export const StaticMenuCol = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const StaticMenuColRight = styled(StaticMenuCol)`
  gap: 32px;
`;

export const StaticButton = styled.button`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  background: transparent !important;
  padding: 0;

  & span {
    color: var(--ywh-royal-blue, #04246b);
    text-align: center;

    /* ywh-button-text-regular */
    font-family: Montserrat;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 24.3px; /* 100% */
  }
`;

export const DashboardCloseWrapper = styled.button`
  border-radius: 100px;
  border: 4px solid var(--White, #fff);
  background: var(--ywh-royal-blue, #04246b);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  position: absolute;
  top: 60px;
  padding: 0;
`;

export const DashboardHideSidebar = styled.div`
  cursor: pointer;
  display: flex;
  padding: 14px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: var(--ywh-alto, #d8d8d8);
  box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.25);
  width: 100%;

  color: var(--ywh-royal-blue, #04246b);
  text-align: center;

  font-family: Montserrat;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24.3px;
`;

export const DashboardMenu = styled.ul`
  display: flex;
  padding-left: 0px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const DashboardMenuItem = styled.li`
  display: flex;
  padding: 32px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px 0px 0px 8px;
  cursor: pointer;
  border-bottom: 0.5px solid #bcbcbc;
  transition: background-color 0.5s ease;

  &.active {
    background-color: #fff;
  }

  & h6 {
    font-size: 15px;
    line-height: 1;
  }

  &:hover {
    background-color: #fff;
  }
`;

export const StaticNavigation = ({ page = '', handleSave }) => {
  const {
    activePage,
    setActivePage,
    openSidebar,
    setOpenSidebar,
    activeAgent,
    loading,
    setLoading,
    setShowDeleteAgent,
    showDeleteAgent,
    activeOfficer
  } = useContext(MainContext);
  const sidebar = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [top, setTop] = useState(116);
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    gsap.to('.sidebar-open', {
      left: openSidebar ? 0 : '-100%',
      ease: Power1.easeInOut,
      duration: 0,
    });
  }, [openSidebar]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY >= 165) {
        setTop(0);
      } else {
        setTop(116);
      }
    });
  }, []);

  const fetchAgents = async (agent) => {
    setLoading(true);

    try {
      if (getUserType() === '2') {
        let data = await getAgents();
        if (data.result) {
          setAgents([agent, ...data.agents.filter((a) => a.id !== agent.id)]);
        }
      } else {
        setAgents([agent]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activePage === 'agent-profile') {
      fetchAgents(activeAgent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeAgent]);

  useLayoutEffect(() => {
    const gctx = gsap.context(() => {});
    return () => gctx.revert();
  }, []);

  const hoverHeight = (document.getElementsByClassName('content-body')?.[0]?.clientHeight ?? 0) - 110;

  return (
    <>
      <StaticMenuContainer top={top}>
        <StaticMenuWrapper>
          <div></div>
          {/* <StaticMenuColLeft onClick={() => setOpenSidebar(!openSidebar)}>
            <SidebarIconWrapper>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M8 19L8 1L8 19ZM12 19L12 1L12 19ZM16 13.375L19 10L16 6.625M4 13.375L1 10L4 6.625"
                  fill="white"
                />
                <path
                  d="M8 19L8 1M12 19L12 1M16 13.375L19 10L16 6.625M4 13.375L1 10L4 6.625"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </SidebarIconWrapper>
            <p>SIDEBAR</p>
          </StaticMenuColLeft> */}
          <StaticMenuColRight>
            {['add-agents', 'add-community', 'edit-community', 'agent-profile-edit', 'add-loan-officer', 'edit-loan-officer'].includes(activePage) ||
            ['add-agents', 'add-community', 'edit-community', 'agent-profile-edit', 'add-loan-officer', 'edit-loan-officer'].includes(page) ||
            showDeleteAgent ? (
              <>
                {page !== 'add-agents' &&
                activePage !== 'add-agents' &&
                page !== 'add-community' &&
                activePage !== 'add-community' ? (
                  <StaticButton
                    onClick={() => {
                      setOpenSidebar(false);
                      if (activePage === 'agent-profile-edit' || page === 'agent-profile-edit')
                        navigate(`/admin/agent/${activeAgent.id}`);
                      if (page === 'agents' || activePage === 'agents') setShowDeleteAgent(false);
                      if (page === 'edit-community' || activePage === 'edit-community')
                        navigate(location.pathname.replace('admin/', '').replace('edit/', ''));
                      if(page.includes('officer') || activePage.includes('officer'))
                        navigate(location.pathname.replace('edit/', ''));
                      return;
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                      <path
                        d="M-5.46392e-07 12.5C-2.44237e-07 19.4125 5.5875 25 12.5 25C19.4125 25 25 19.4125 25 12.5C25 5.5875 19.4125 -8.48547e-07 12.5 -5.46392e-07C5.5875 -2.44237e-07 -8.48547e-07 5.5875 -5.46392e-07 12.5ZM17.875 7.125C17.9909 7.24064 18.0828 7.378 18.1455 7.52922C18.2083 7.68043 18.2406 7.84254 18.2406 8.00625C18.2406 8.16996 18.2083 8.33206 18.1455 8.48328C18.0828 8.6345 17.9909 8.77186 17.875 8.8875L14.2625 12.5L17.875 16.1125C18.1087 16.3462 18.24 16.6632 18.24 16.9937C18.24 17.3243 18.1087 17.6413 17.875 17.875C17.6413 18.1087 17.3243 18.24 16.9937 18.24C16.8301 18.24 16.668 18.2078 16.5168 18.1452C16.3656 18.0825 16.2282 17.9907 16.1125 17.875L12.5 14.2625L8.8875 17.875C8.65378 18.1087 8.33678 18.24 8.00625 18.24C7.67572 18.24 7.35872 18.1087 7.125 17.875C6.89128 17.6413 6.75997 17.3243 6.75997 16.9938C6.75997 16.6632 6.89128 16.3462 7.125 16.1125L10.7375 12.5L7.125 8.8875C7.00927 8.77177 6.91747 8.63438 6.85484 8.48318C6.79221 8.33197 6.75997 8.16991 6.75997 8.00625C6.75997 7.84259 6.79221 7.68053 6.85484 7.52932C6.91747 7.37811 7.00927 7.24073 7.125 7.125C7.24073 7.00927 7.37811 6.91747 7.52932 6.85484C7.68052 6.79221 7.84259 6.75998 8.00625 6.75998C8.16991 6.75998 8.33197 6.79221 8.48318 6.85484C8.63438 6.91747 8.77177 7.00927 8.8875 7.125L12.5 10.7375L16.1125 7.125C16.5875 6.65 17.3875 6.65 17.875 7.125Z"
                        fill="#CDA07D"
                      />
                    </svg>
                    <span>Cancel</span>
                  </StaticButton>
                ) : (
                  <StaticButton onClick={() => (window.location.href = '/admin/agents')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                      <path
                        d="M12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0ZM8.17108 7.14265H16.8274C17.41 7.1821 17.8496 7.60602 17.8574 8.14363V16.8289C17.8161 17.4343 17.3756 17.85 16.8274 17.8574H8.17108C7.56608 17.8161 7.15 17.3767 7.14265 16.8289V8.14363C7.17602 7.56381 7.65871 7.14952 8.17108 7.14265ZM9.62829 9.11408C9.31765 9.12179 9.11733 9.36088 9.11406 9.62983V15.3427C9.12213 15.6528 9.36006 15.8552 9.62829 15.8585H15.3702C15.681 15.8504 15.8827 15.6115 15.8859 15.3427V9.62981C15.8783 9.31846 15.6398 9.11727 15.3702 9.11406H9.62829V9.11408Z"
                        fill="#04246B"
                      />
                    </svg>
                    <span>Home</span>
                  </StaticButton>
                )}
                <StaticButton
                  onClick={() => {
                    if (showDeleteAgent) setShowDeleteAgent(false);
                    else handleSave();

                    setOpenSidebar(false);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      d="M10.75 18.25L19.5625 9.4375L17.8125 7.6875L10.75 14.75L7.1875 11.1875L5.4375 12.9375L10.75 18.25ZM12.5 25C10.7708 25 9.14583 24.6717 7.625 24.015C6.10417 23.3583 4.78125 22.4679 3.65625 21.3437C2.53125 20.2188 1.64083 18.8958 0.985 17.375C0.329167 15.8542 0.000833333 14.2292 0 12.5C0 10.7708 0.328333 9.14583 0.985 7.625C1.64167 6.10417 2.53208 4.78125 3.65625 3.65625C4.78125 2.53125 6.10417 1.64083 7.625 0.985C9.14583 0.329167 10.7708 0.000833333 12.5 0C14.2292 0 15.8542 0.328333 17.375 0.985C18.8958 1.64167 20.2188 2.53208 21.3437 3.65625C22.4687 4.78125 23.3596 6.10417 24.0162 7.625C24.6729 9.14583 25.0008 10.7708 25 12.5C25 14.2292 24.6717 15.8542 24.015 17.375C23.3583 18.8958 22.4679 20.2188 21.3437 21.3437C20.2188 22.4687 18.8958 23.3596 17.375 24.0162C15.8542 24.6729 14.2292 25.0008 12.5 25Z"
                      fill="#5284E0"
                    />
                  </svg>
                  <span>Save</span>
                </StaticButton>
              </>
            ) : (
              <>
                <StaticButton onClick={() => (window.location.href = '/admin/agents')}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                      d="M12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0ZM8.17108 7.14265H16.8274C17.41 7.1821 17.8496 7.60602 17.8574 8.14363V16.8289C17.8161 17.4343 17.3756 17.85 16.8274 17.8574H8.17108C7.56608 17.8161 7.15 17.3767 7.14265 16.8289V8.14363C7.17602 7.56381 7.65871 7.14952 8.17108 7.14265ZM9.62829 9.11408C9.31765 9.12179 9.11733 9.36088 9.11406 9.62983V15.3427C9.12213 15.6528 9.36006 15.8552 9.62829 15.8585H15.3702C15.681 15.8504 15.8827 15.6115 15.8859 15.3427V9.62981C15.8783 9.31846 15.6398 9.11727 15.3702 9.11406H9.62829V9.11408Z"
                      fill="#04246B"
                    />
                  </svg>
                  <span>Home</span>
                </StaticButton>
                {activePage !== 'agents' && activePage !== 'loan-officers' && getUserType() === '2' && (
                  <StaticButton onClick={() => (window.location.href =  activePage.includes('officer') ? '/admin/loan-officers' :'/admin/agents')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                      <path
                        d="M0 12.5C0 19.4032 5.59675 25 12.5 25C19.4032 25 25 19.4032 25 12.5C25 5.59675 19.4032 0 12.5 0C5.59675 0 0 5.59675 0 12.5ZM12.7794 7.00961C12.8691 7.09855 12.9404 7.20428 12.9892 7.32076C13.038 7.43724 13.0634 7.56219 13.0639 7.68848C13.0644 7.81477 13.04 7.93992 12.9921 8.05679C12.9442 8.17366 12.8738 8.27995 12.7849 8.36959L9.64062 11.5385H17.6683C17.9233 11.5385 18.1679 11.6398 18.3482 11.8201C18.5285 12.0004 18.6298 12.245 18.6298 12.5C18.6298 12.755 18.5285 12.9996 18.3482 13.1799C18.1679 13.3602 17.9233 13.4615 17.6683 13.4615H9.64062L12.7849 16.6304C12.8738 16.7201 12.9442 16.8265 12.992 16.9434C13.0399 17.0604 13.0642 17.1856 13.0636 17.3119C13.0631 17.4383 13.0376 17.5633 12.9888 17.6798C12.9399 17.7963 12.8686 17.902 12.7788 17.991C12.6891 18.0799 12.5827 18.1503 12.4658 18.1982C12.3489 18.246 12.2237 18.2703 12.0973 18.2698C11.971 18.2692 11.846 18.2438 11.7295 18.1949C11.613 18.146 11.5072 18.0747 11.4183 17.985L6.64724 13.1773C6.46851 12.9972 6.36822 12.7537 6.36822 12.5C6.36822 12.2463 6.46851 12.0028 6.64724 11.8227L11.4183 7.01502C11.5072 6.92518 11.613 6.85376 11.7296 6.80485C11.8462 6.75594 11.9713 6.73051 12.0977 6.73001C12.2242 6.72951 12.3495 6.75394 12.4664 6.80192C12.5834 6.8499 12.6898 6.92048 12.7794 7.00961Z"
                        fill="#04246B"
                      />
                    </svg>
                    <span>Back</span>
                  </StaticButton>
                )}
              </>
            )}
            {(['agent-profile', 'view-community', 'officer-profile'].includes(page) ||
              (['agents', 'loan-officers'].includes(activePage) && !showDeleteAgent)) && (
              <StaticButton
                onClick={() => {
                  if (page === 'agent-profile') navigate(`/admin/agent/edit/${activeAgent.id}`);
                  if (page === 'officer-profile') navigate(`/admin/officer/edit/${activeOfficer.id}`);
                  if (page === 'view-community')
                    navigate(`/admin${location.pathname.replace('/community/', '/community/edit/')}`);
                  if (page === 'agents' || activePage === 'agents' || page.includes('officer') || activePage.includes('officer')) {
                    setShowDeleteAgent(true);
                  }
                  return;
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path
                    d="M12.5 0C5.5875 0 0 5.5875 0 12.5C0 19.4125 5.5875 25 12.5 25C19.4125 25 25 19.4125 25 12.5C25 5.5875 19.4125 0 12.5 0ZM16.375 6.3375C16.55 6.3375 16.725 6.4 16.875 6.5375L18.4625 8.125C18.75 8.4 18.75 8.8375 18.4625 9.1L17.2125 10.35L14.65 7.7875L15.9 6.5375C16.025 6.4 16.2 6.3375 16.375 6.3375ZM13.9125 8.5125L16.4875 11.0875L8.9125 18.6625H6.3375V16.0875L13.9125 8.5125Z"
                    fill="#04246B"
                  />
                </svg>
                <span>Edit</span>
              </StaticButton>
            )}
            <StaticButton onClick={() => (window.location.href = '/admin/logout')}>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                <path
                  d="M13.2406 13.7504L10.3649 16.6136C10.2477 16.7298 10.1547 16.8681 10.0913 17.0205C10.0278 17.1728 9.9951 17.3362 9.9951 17.5013C9.9951 17.6664 10.0278 17.8298 10.0913 17.9821C10.1547 18.1345 10.2477 18.2728 10.3649 18.389C10.4812 18.5062 10.6194 18.5992 10.7718 18.6627C10.9242 18.7262 11.0876 18.7588 11.2526 18.7588C11.4177 18.7588 11.5811 18.7262 11.7335 18.6627C11.8858 18.5992 12.0241 18.5062 12.1404 18.389L17.1415 13.3878C17.2554 13.2689 17.3446 13.1287 17.4041 12.9752C17.5291 12.6708 17.5291 12.3294 17.4041 12.025C17.3446 11.8715 17.2554 11.7313 17.1415 11.6124L12.1404 6.61125C12.0238 6.49467 11.8854 6.4022 11.7331 6.33911C11.5808 6.27602 11.4175 6.24355 11.2526 6.24355C11.0878 6.24355 10.9245 6.27602 10.7722 6.33911C10.6199 6.4022 10.4815 6.49467 10.3649 6.61125C10.2484 6.72782 10.1559 6.86622 10.0928 7.01853C10.0297 7.17084 9.99723 7.33409 9.99723 7.49896C9.99723 7.66382 10.0297 7.82707 10.0928 7.97938C10.1559 8.13169 10.2484 8.27009 10.3649 8.38666L13.2406 11.2498H1.25029C0.918695 11.2498 0.600678 11.3816 0.366202 11.616C0.131727 11.8505 0 12.1685 0 12.5001C0 12.8317 0.131727 13.1497 0.366202 13.3842C0.600678 13.6187 0.918695 13.7504 1.25029 13.7504H13.2406ZM12.5029 -0.00280504C10.1663 -0.0132372 7.8734 0.63136 5.88447 1.85787C3.89553 3.08438 2.29011 4.84372 1.25029 6.93632C1.10107 7.23476 1.07652 7.58025 1.18203 7.8968C1.28755 8.21334 1.51449 8.475 1.81293 8.62422C2.11136 8.77344 2.45686 8.79799 2.7734 8.69248C3.08994 8.58696 3.3516 8.36003 3.50082 8.06159C4.29125 6.46536 5.49358 5.10917 6.98358 4.13315C8.47357 3.15713 10.1972 2.5967 11.9763 2.50977C13.7553 2.42285 15.5254 2.81258 17.1034 3.63869C18.6815 4.4648 20.0103 5.69732 20.9526 7.20888C21.8948 8.72044 22.4164 10.4562 22.4633 12.2368C22.5102 14.0174 22.0808 15.7782 21.2194 17.3373C20.358 18.8964 19.0959 20.1971 17.5635 21.1052C16.0312 22.0132 14.2841 22.4956 12.5029 22.5025C10.6386 22.5105 8.80976 21.9928 7.22631 21.0087C5.64286 20.0246 4.36897 18.6139 3.55083 16.9387C3.40161 16.6402 3.13995 16.4133 2.82341 16.3078C2.50687 16.2023 2.16138 16.2268 1.86294 16.376C1.5645 16.5253 1.33756 16.7869 1.23205 17.1035C1.12653 17.42 1.15109 17.7655 1.30031 18.0639C2.29157 20.0588 3.79779 21.7526 5.66317 22.9701C7.52854 24.1877 9.68533 24.8848 11.9104 24.9893C14.1356 25.0938 16.3482 24.602 18.3195 23.5646C20.2908 22.5273 21.9491 20.9821 23.123 19.089C24.2969 17.1958 24.9437 15.0234 24.9965 12.7965C25.0493 10.5695 24.5062 8.3689 23.4233 6.42224C22.3404 4.47558 20.7572 2.85357 18.8373 1.72398C16.9173 0.594391 14.7305 -0.00175923 12.5029 -0.00280504Z"
                  fill="#04246B"
                />
              </svg>
              <span>Logout</span>
            </StaticButton>
          </StaticMenuColRight>
        </StaticMenuWrapper>
      </StaticMenuContainer>
      <DashboardSidebarContainer className="sidebar-open" ref={sidebar} top={top}>
        <DashboardSidebarWrapper>
          <DashboardHideSidebar onClick={() => setOpenSidebar(false)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path
                d="M0.499999 13C0.5 19.9125 6.0875 25.5 13 25.5C19.9125 25.5 25.5 19.9125 25.5 13C25.5 6.0875 19.9125 0.499999 13 0.499999C6.0875 0.5 0.499999 6.0875 0.499999 13ZM18.375 7.625C18.4909 7.74064 18.5828 7.878 18.6455 8.02922C18.7083 8.18043 18.7406 8.34254 18.7406 8.50625C18.7406 8.66996 18.7083 8.83206 18.6455 8.98328C18.5828 9.1345 18.4909 9.27186 18.375 9.3875L14.7625 13L18.375 16.6125C18.6087 16.8462 18.74 17.1632 18.74 17.4937C18.74 17.8243 18.6087 18.1413 18.375 18.375C18.1413 18.6087 17.8243 18.74 17.4937 18.74C17.3301 18.74 17.168 18.7078 17.0168 18.6452C16.8656 18.5825 16.7282 18.4907 16.6125 18.375L13 14.7625L9.3875 18.375C9.15378 18.6087 8.83678 18.74 8.50625 18.74C8.17572 18.74 7.85872 18.6087 7.625 18.375C7.39128 18.1413 7.25997 17.8243 7.25997 17.4938C7.25997 17.1632 7.39128 16.8462 7.625 16.6125L11.2375 13L7.625 9.3875C7.50927 9.27177 7.41747 9.13438 7.35484 8.98318C7.29221 8.83197 7.25997 8.66991 7.25997 8.50625C7.25997 8.34259 7.29221 8.18053 7.35484 8.02932C7.41747 7.87811 7.50927 7.74073 7.625 7.625C7.74073 7.50927 7.87811 7.41747 8.02932 7.35484C8.18052 7.29221 8.34259 7.25998 8.50625 7.25998C8.66991 7.25998 8.83197 7.29221 8.98318 7.35484C9.13438 7.41747 9.27177 7.50927 9.3875 7.625L13 11.2375L16.6125 7.625C17.0875 7.15 17.8875 7.15 18.375 7.625Z"
                fill="#04246B"
              />
            </svg>
            Hide Sidebar
          </DashboardHideSidebar>
          {activePage === 'agent-profile' ? (
            <AgentListWrapper>
              {!agents && loading && <Loader />}
              {agents &&
                agents.map((a, index) => (
                  <AgentListItem
                    key={index}
                    onClick={() => (window.location.href = '/admin/agent/' + a.id)}
                    active={a.id === activeAgent.id}
                    photo={a.photo}
                    name={`${a.first_name} ${a.last_name}`}
                  />
                ))}
            </AgentListWrapper>
          ) : (
            <DashboardMenu>
              <DashboardMenuItem
                className={activePage === 'agents' ? 'active' : ''}
                onClick={() => {
                  setOpenSidebar(!openSidebar);
                  setActivePage('agents');
                  navigate('/admin/agents', {
                    state: {
                      activePage: 'agents',
                    },
                  });
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24" fill="none">
                  <path
                    d="M18 0C19.3537 0 20.652 0.593389 21.6092 1.64963C22.5664 2.70587 23.1042 4.13844 23.1042 5.63218C23.1042 7.12593 22.5664 8.5585 21.6092 9.61474C20.652 10.671 19.3537 11.2644 18 11.2644C16.6463 11.2644 15.348 10.671 14.3908 9.61474C13.4336 8.5585 12.8958 7.12593 12.8958 5.63218C12.8958 4.13844 13.4336 2.70587 14.3908 1.64963C15.348 0.593389 16.6463 0 18 0ZM7.79167 4.02299C8.60833 4.02299 9.36667 4.26437 10.0229 4.69885C9.80417 7 10.4167 9.28506 11.6708 11.0713C10.9417 12.6161 9.48333 13.6782 7.79167 13.6782C6.63134 13.6782 5.51855 13.1695 4.69807 12.2642C3.8776 11.3588 3.41667 10.1309 3.41667 8.85057C3.41667 7.57022 3.8776 6.3423 4.69807 5.43695C5.51855 4.53161 6.63134 4.02299 7.79167 4.02299ZM28.2083 4.02299C29.3687 4.02299 30.4815 4.53161 31.3019 5.43695C32.1224 6.3423 32.5833 7.57022 32.5833 8.85057C32.5833 10.1309 32.1224 11.3588 31.3019 12.2642C30.4815 13.1695 29.3687 13.6782 28.2083 13.6782C26.5167 13.6782 25.0583 12.6161 24.3292 11.0713C25.6006 9.25998 26.1908 6.97779 25.9771 4.69885C26.6333 4.26437 27.3917 4.02299 28.2083 4.02299ZM8.52083 20.5172C8.52083 17.1862 12.7646 14.4828 18 14.4828C23.2354 14.4828 27.4792 17.1862 27.4792 20.5172V23.3333H8.52083V20.5172ZM0.5 23.3333V20.9195C0.5 18.6828 3.25625 16.8 6.98958 16.2529C6.12917 17.3471 5.60417 18.8598 5.60417 20.5172V23.3333H0.5ZM35.5 23.3333H30.3958V20.5172C30.3958 18.8598 29.8708 17.3471 29.0104 16.2529C32.7437 16.8 35.5 18.6828 35.5 20.9195V23.3333Z"
                    fill="#04246B"
                  />
                </svg>
                <h6>View All Agents</h6>
              </DashboardMenuItem>
              <DashboardMenuItem
                className={activePage === 'add-agents' ? 'active' : ''}
                onClick={() => {
                  setOpenSidebar(!openSidebar);
                  setActivePage('add-agents');
                  navigate('/admin/register/agent');
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                  <path
                    d="M12.3529 0.333252C10.4808 0.333252 8.68538 1.07695 7.3616 2.40073C6.03781 3.72452 5.29412 5.51996 5.29412 7.39208C5.29412 9.26419 6.03781 11.0596 7.3616 12.3834C8.68538 13.7072 10.4808 14.4509 12.3529 14.4509C14.2251 14.4509 16.0205 13.7072 17.3443 12.3834C18.6681 11.0596 19.4118 9.26419 19.4118 7.39208C19.4118 5.51996 18.6681 3.72452 17.3443 2.40073C16.0205 1.07695 14.2251 0.333252 12.3529 0.333252ZM3.54529 16.2156C3.08053 16.2137 2.61998 16.3037 2.19004 16.4802C1.76011 16.6567 1.36924 16.9163 1.03987 17.2442C0.710495 17.5721 0.449091 17.9618 0.270646 18.391C0.0922022 18.8201 0.000228551 19.2803 0 19.745C0 22.7291 1.47 24.9791 3.76765 26.4456C6.03 27.8874 9.07941 28.5685 12.3529 28.5685C13.0765 28.5685 13.7929 28.535 14.4882 28.468C13.1028 26.7463 12.3492 24.6019 12.3529 22.3921C12.3529 20.045 13.1859 17.8921 14.5712 16.2156H3.54706H3.54529ZM22.0588 30.3333C24.165 30.3333 26.1848 29.4966 27.6741 28.0073C29.1633 26.5181 30 24.4982 30 22.3921C30 20.2859 29.1633 18.2661 27.6741 16.7768C26.1848 15.2876 24.165 14.4509 22.0588 14.4509C19.9527 14.4509 17.9328 15.2876 16.4436 16.7768C14.9543 18.2661 14.1176 20.2859 14.1176 22.3921C14.1176 24.4982 14.9543 26.5181 16.4436 28.0073C17.9328 29.4966 19.9527 30.3333 22.0588 30.3333ZM22.0588 17.9803C22.2928 17.9803 22.5173 18.0733 22.6827 18.2387C22.8482 18.4042 22.9412 18.6286 22.9412 18.8627V21.5097H25.5882C25.8223 21.5097 26.0467 21.6027 26.2122 21.7682C26.3776 21.9336 26.4706 22.1581 26.4706 22.3921C26.4706 22.6261 26.3776 22.8505 26.2122 23.016C26.0467 23.1815 25.8223 23.2744 25.5882 23.2744H22.9412V25.9215C22.9412 26.1555 22.8482 26.3799 22.6827 26.5454C22.5173 26.7109 22.2928 26.8038 22.0588 26.8038C21.8248 26.8038 21.6004 26.7109 21.4349 26.5454C21.2694 26.3799 21.1765 26.1555 21.1765 25.9215V23.2744H18.5294C18.2954 23.2744 18.071 23.1815 17.9055 23.016C17.74 22.8505 17.6471 22.6261 17.6471 22.3921C17.6471 22.1581 17.74 21.9336 17.9055 21.7682C18.071 21.6027 18.2954 21.5097 18.5294 21.5097H21.1765V18.8627C21.1765 18.6286 21.2694 18.4042 21.4349 18.2387C21.6004 18.0733 21.8248 17.9803 22.0588 17.9803Z"
                    fill="#04246B"
                  />
                </svg>
                <h6>Add Agent</h6>
              </DashboardMenuItem>
              <DashboardMenuItem
                className={activePage === 'communities' ? 'active' : ''}
                onClick={() => {
                  setOpenSidebar(!openSidebar);
                  setActivePage('communities');
                  navigate('/admin/communities');
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32" fill="none">
                  <path
                    d="M13.0015 0.333252C7.89185 0.333252 3.70435 4.50825 3.70435 9.60388C3.70435 11.5783 4.33497 13.4133 5.40216 14.9214L11.8668 26.0973C12.7722 27.2801 13.374 27.0554 14.1268 26.0348L21.2575 13.9004C21.4012 13.6398 21.5143 13.3623 21.6128 13.0789C22.0653 11.9762 22.298 10.7958 22.2978 9.60388C22.2981 4.50825 18.1118 0.333252 13.0015 0.333252ZM13.0015 4.677C15.7534 4.677 17.9415 6.86013 17.9415 9.60388C17.9415 12.3476 15.7534 14.5298 13.0015 14.5298C10.25 14.5298 8.06091 12.3479 8.06091 9.60388C8.06091 6.86013 10.25 4.677 13.0015 4.677Z"
                    fill="#04246B"
                  />
                  <path
                    d="M13.0077 16.8958L12.9927 16.9351C12.9974 16.9233 13.0011 16.9111 13.0058 16.8992L13.0077 16.8958Z"
                    fill="#04246B"
                  />
                  <path
                    d="M8.00187 21.9348C3.5875 22.5586 0.5 24.0508 0.5 26.2473C0.5 29.2061 5.65875 31.6045 13 31.6045C20.3413 31.6045 25.5 29.2061 25.5 26.2473C25.5 24.0508 22.4128 22.5586 17.9988 21.9348L17.3872 22.9761C20.7141 23.4376 23 24.4076 23 25.5333C23 27.1114 18.5228 28.3904 13 28.3904C7.47719 28.3904 3 27.1114 3 25.5333C2.99969 24.4114 5.27063 23.4423 8.60781 22.9789C8.40625 22.6308 8.20375 22.2833 8.00187 21.9348Z"
                    fill="#04246B"
                  />
                </svg>
                <h6>View All Communities</h6>
              </DashboardMenuItem>
              <DashboardMenuItem
                className={activePage === 'add-community' || activePage === 'edit-community' ? 'active' : ''}
                onClick={() => {
                  setOpenSidebar(!openSidebar);
                  setActivePage('add-community');
                  navigate('/admin/community/new');
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="34" viewBox="0 0 26 34" fill="none">
                  <path
                    d="M7.84741 23.8033C3.52393 24.4142 0.5 25.8757 0.5 28.027C0.5 30.9248 5.55253 33.2739 12.7426 33.2739C19.9327 33.2739 24.9852 30.9248 24.9852 28.027C24.9852 25.8757 21.9616 24.4142 17.6384 23.8033L17.0395 24.8231C20.2978 25.2752 22.5367 26.2252 22.5367 27.3276C22.5367 28.8733 18.1517 30.126 12.7426 30.126C7.33352 30.126 2.94852 28.8733 2.94852 27.3276C2.94822 26.2289 5.17239 25.2798 8.44087 24.8259C8.24345 24.4849 8.04512 24.1446 7.84741 23.8033Z"
                    fill="#04246B"
                  />
                  <path
                    d="M20.8789 0.604492C21.5143 0.604492 22.0342 1.15552 22.0342 1.82899V4.27798H24.3447C24.9801 4.27798 25.4999 4.82901 25.4999 5.50248C25.4999 6.17596 24.9801 6.72698 24.3447 6.72698H22.0342V9.17597C22.0342 9.84945 21.5143 10.4005 20.8789 10.4005C20.2435 10.4005 19.7236 9.84945 19.7236 9.17597V6.72698H17.4131C16.7777 6.72698 16.2579 6.17596 16.2579 5.50248C16.2579 4.82901 16.7777 4.27798 17.4131 4.27798H19.7236V1.82899C19.7236 1.15552 20.2435 0.604492 20.8789 0.604492ZM12.7921 15.2985C14.0629 15.2985 15.1026 14.1964 15.1026 12.8495C15.1026 11.5025 14.0629 10.4005 12.7921 10.4005C11.5213 10.4005 10.4816 11.5025 10.4816 12.8495C10.4816 14.1964 11.5213 15.2985 12.7921 15.2985ZM15.9344 3.629C15.4261 4.06982 15.1026 4.74329 15.1026 5.50248C15.1026 6.84943 16.1423 7.95148 17.4131 7.95148H18.5684V9.17597C18.5684 10.5229 19.6081 11.625 20.8789 11.625C21.2486 11.625 21.5952 11.527 21.9071 11.3678C21.9879 11.9188 22.0342 12.4944 22.0342 13.0944C22.0342 16.9883 19.2038 21.5679 13.5546 26.8455C13.1156 27.2496 12.4571 27.2496 12.0181 26.8455C6.38042 21.5679 3.55004 16.9883 3.55004 13.0944C3.55004 6.99637 7.94002 3.05349 12.7921 3.05349C13.878 3.05349 14.9409 3.24941 15.9344 3.629Z"
                    fill="#04246B"
                  />
                </svg>
                <h6>Add Community</h6>
              </DashboardMenuItem>
              <DashboardMenuItem
                className={activePage === 'loan-officers' ? 'active' : ''}
                onClick={() => {
                  setOpenSidebar(!openSidebar);
                  setActivePage('loan-officers');
                  navigate('/admin/loan-officers', {
                    state: {
                      activePage: 'loan-officers',
                    },
                  });
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24" fill="none">
                  <path
                    d="M18 0C19.3537 0 20.652 0.593389 21.6092 1.64963C22.5664 2.70587 23.1042 4.13844 23.1042 5.63218C23.1042 7.12593 22.5664 8.5585 21.6092 9.61474C20.652 10.671 19.3537 11.2644 18 11.2644C16.6463 11.2644 15.348 10.671 14.3908 9.61474C13.4336 8.5585 12.8958 7.12593 12.8958 5.63218C12.8958 4.13844 13.4336 2.70587 14.3908 1.64963C15.348 0.593389 16.6463 0 18 0ZM7.79167 4.02299C8.60833 4.02299 9.36667 4.26437 10.0229 4.69885C9.80417 7 10.4167 9.28506 11.6708 11.0713C10.9417 12.6161 9.48333 13.6782 7.79167 13.6782C6.63134 13.6782 5.51855 13.1695 4.69807 12.2642C3.8776 11.3588 3.41667 10.1309 3.41667 8.85057C3.41667 7.57022 3.8776 6.3423 4.69807 5.43695C5.51855 4.53161 6.63134 4.02299 7.79167 4.02299ZM28.2083 4.02299C29.3687 4.02299 30.4815 4.53161 31.3019 5.43695C32.1224 6.3423 32.5833 7.57022 32.5833 8.85057C32.5833 10.1309 32.1224 11.3588 31.3019 12.2642C30.4815 13.1695 29.3687 13.6782 28.2083 13.6782C26.5167 13.6782 25.0583 12.6161 24.3292 11.0713C25.6006 9.25998 26.1908 6.97779 25.9771 4.69885C26.6333 4.26437 27.3917 4.02299 28.2083 4.02299ZM8.52083 20.5172C8.52083 17.1862 12.7646 14.4828 18 14.4828C23.2354 14.4828 27.4792 17.1862 27.4792 20.5172V23.3333H8.52083V20.5172ZM0.5 23.3333V20.9195C0.5 18.6828 3.25625 16.8 6.98958 16.2529C6.12917 17.3471 5.60417 18.8598 5.60417 20.5172V23.3333H0.5ZM35.5 23.3333H30.3958V20.5172C30.3958 18.8598 29.8708 17.3471 29.0104 16.2529C32.7437 16.8 35.5 18.6828 35.5 20.9195V23.3333Z"
                    fill="#04246B"
                  />
                </svg>
                <h6>View All Loan Officers</h6>
              </DashboardMenuItem>
              <DashboardMenuItem
                className={activePage === 'add-loan-officer' ? 'active' : ''}
                onClick={() => {
                  setOpenSidebar(!openSidebar);
                  setActivePage('add-loan-officer');
                  navigate('/admin/add/loan-officer');
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                  <path
                    d="M12.3529 0.333252C10.4808 0.333252 8.68538 1.07695 7.3616 2.40073C6.03781 3.72452 5.29412 5.51996 5.29412 7.39208C5.29412 9.26419 6.03781 11.0596 7.3616 12.3834C8.68538 13.7072 10.4808 14.4509 12.3529 14.4509C14.2251 14.4509 16.0205 13.7072 17.3443 12.3834C18.6681 11.0596 19.4118 9.26419 19.4118 7.39208C19.4118 5.51996 18.6681 3.72452 17.3443 2.40073C16.0205 1.07695 14.2251 0.333252 12.3529 0.333252ZM3.54529 16.2156C3.08053 16.2137 2.61998 16.3037 2.19004 16.4802C1.76011 16.6567 1.36924 16.9163 1.03987 17.2442C0.710495 17.5721 0.449091 17.9618 0.270646 18.391C0.0922022 18.8201 0.000228551 19.2803 0 19.745C0 22.7291 1.47 24.9791 3.76765 26.4456C6.03 27.8874 9.07941 28.5685 12.3529 28.5685C13.0765 28.5685 13.7929 28.535 14.4882 28.468C13.1028 26.7463 12.3492 24.6019 12.3529 22.3921C12.3529 20.045 13.1859 17.8921 14.5712 16.2156H3.54706H3.54529ZM22.0588 30.3333C24.165 30.3333 26.1848 29.4966 27.6741 28.0073C29.1633 26.5181 30 24.4982 30 22.3921C30 20.2859 29.1633 18.2661 27.6741 16.7768C26.1848 15.2876 24.165 14.4509 22.0588 14.4509C19.9527 14.4509 17.9328 15.2876 16.4436 16.7768C14.9543 18.2661 14.1176 20.2859 14.1176 22.3921C14.1176 24.4982 14.9543 26.5181 16.4436 28.0073C17.9328 29.4966 19.9527 30.3333 22.0588 30.3333ZM22.0588 17.9803C22.2928 17.9803 22.5173 18.0733 22.6827 18.2387C22.8482 18.4042 22.9412 18.6286 22.9412 18.8627V21.5097H25.5882C25.8223 21.5097 26.0467 21.6027 26.2122 21.7682C26.3776 21.9336 26.4706 22.1581 26.4706 22.3921C26.4706 22.6261 26.3776 22.8505 26.2122 23.016C26.0467 23.1815 25.8223 23.2744 25.5882 23.2744H22.9412V25.9215C22.9412 26.1555 22.8482 26.3799 22.6827 26.5454C22.5173 26.7109 22.2928 26.8038 22.0588 26.8038C21.8248 26.8038 21.6004 26.7109 21.4349 26.5454C21.2694 26.3799 21.1765 26.1555 21.1765 25.9215V23.2744H18.5294C18.2954 23.2744 18.071 23.1815 17.9055 23.016C17.74 22.8505 17.6471 22.6261 17.6471 22.3921C17.6471 22.1581 17.74 21.9336 17.9055 21.7682C18.071 21.6027 18.2954 21.5097 18.5294 21.5097H21.1765V18.8627C21.1765 18.6286 21.2694 18.4042 21.4349 18.2387C21.6004 18.0733 21.8248 17.9803 22.0588 17.9803Z"
                    fill="#04246B"
                  />
                </svg>
                <h6>Add Loan Officer</h6>
              </DashboardMenuItem>
            </DashboardMenu>
          )}
        </DashboardSidebarWrapper>
      </DashboardSidebarContainer>
      {getUserType() === '2' && (
        <>
          <DashboardSidebarHover
            style={{ zIndex: openSidebar ? 0 : 999, height: `${hoverHeight + 110}px` }}
            onMouseEnter={() => setOpenSidebar(true)}
          />
          <DashboardCloseWrapper onClick={() => setOpenSidebar(true)} style={{ zIndex: openSidebar ? 0 : 999 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M7.08333 16.5L7.08333 1.5L7.08333 16.5ZM10.4167 16.5L10.4167 1.5L10.4167 16.5ZM13.75 11.8125L16.25 9L13.75 6.1875M3.75 11.8125L1.25 9L3.75 6.1875"
                fill="white"
              />
              <path
                d="M7.08333 16.5L7.08333 1.5M10.4167 16.5L10.4167 1.5M13.75 11.8125L16.25 9L13.75 6.1875M3.75 11.8125L1.25 9L3.75 6.1875"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </DashboardCloseWrapper>
        </>
      )}
    </>
  );
};

const Layout = ({ children }) => {
  const { activePage, setActivePage } = useContext(MainContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activePage]);

  return (
    <>
      <StaticNavigation />

      <Wrapper>
        <section>{children}</section>
      </Wrapper>
    </>
  );
};

export default Layout;
